module.exports = __webpack_public_path__ + "img/834317d.jpg";